import { graphql } from '@/gql';

graphql(`
  fragment HomeServiceOrderFragment on HomeServiceOrderType {
    id
    callLogId
    callerId
    operatorId
    serviceType
    frequency
    budget
    homeServiceName
    pricingType
    hours
    providerRate
    gogoFee
    findersFee
    membershipFee
    estimatedDurationHours
    status
    cancellationReason
    nextFollowUpDueAt
    followUpReason
    orderNotes
    canceledAt
    completedAt
    createdAt
    updatedAt
    jobScheduledAt
    jobEndedAt
    customerPaidStatus
    hearAboutUs
    caller {
      id
      firstName
      lastName
      phoneNumber
      streetAddress
      city
      state
      zip
      timeZone
      callerSubscriptions {
        planName
      }
    }
    operator {
      firstName
      lastName
    }
    homeServiceProviders {
      id
      firstName
      lastName
      phoneNumber
      email
      city
      state
      zip
      providerNotes
      source
      isActive
      backgroundCheck
      businessName
      backgroundCheckedAt
      backgroundCheckSourced
      paymentOptions
      professionalProfileUrl
      createdAt
      updatedAt
      rates {
        id
        providerId
        serviceType
        description
        hourlyRate
        currency
        isActive
        createdAt
        updatedAt
      }
      homeServiceOrderProvider {
        id
        homeServiceOrderId
        homeServiceProviderId
        role
        acceptedAt
        isCurrentProvider
        assignedBy
        assignmentNotes
        assignedAt
        removedAt
        createdAt
        updatedAt
      }
    }
  }
`);
